export const PERMS = {
    READ: 'warehousing_receipts.read',
    UPDATE: 'warehousing_receipts.update',
    DELETE: 'warehousing_receipts.delete',
    CREATE: 'warehousing_receipts.create',
    EXPORT: 'warehousing_receipts.export',
}